import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { BuyerListPermissionsQuery } from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";

const buyerListPermissionsQuery = graphql(`
  query buyerListPermissions($id: String!) {
    buyerListPermissions(id: $id) {
      objectId
      accessorId
      accessorType
      roleName
    }
  }
`);

export function useBuyerListPermissions(
  id: string,
  options?: UseQueryOptions<
    BuyerListPermissionsQuery,
    unknown,
    BuyerListPermissionsQuery,
    QueryKey
  >,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["buyerLists", id, "permissions"],
    buyerListPermissionsQuery,
    [{ id }],
    options,
  );
  return { data: data?.buyerListPermissions, ...rest };
}
